import React from "react";
import { Modal, Button, Image, Form } from "react-bootstrap";
import { FORMAT_DOC_PDF, STATUS } from "../../constant";
import radioUncheck from "../../assets/Radio_Button.svg";
import radioblue from "../../assets/radio_blue.svg";
import { Field } from "../../component";
import { DisplayAttachments } from "./displayAttachments";
import { UploadMinutesForReviewComponent } from "./UploadMinutesForReview/UploadMinutesForReview";
import TooltipCustom from "../createAgenda/TooltipCustom";
import Info from "../../assets/info-tool.svg";

export const ReviewAndSend = ({
  isLoading,
  modalClass,
  show,
  title,
  content,
  closeBtn,
  closeHandler,
  saveHandler,
  saveBtn,
  isChecked,
  isNotChecked,
  checkBoxChange,
  toggleAttachementDisplay,
  onToggleAttachment,
  files,
  projectMom,
  onBlur,
  description,
  errors,
  onRemoveFile,
  ContentTemplate,
  closeButton = true
}) =>
  (show && (
    <Modal
      show={show}
      onHide={closeHandler}
      className="ministry-review-issue-modal"
    >
      <section className="ministry-review-modal">
        <Modal.Header closeButton>
          <Modal.Title>{"Ministry Review Confirmation"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ministry-review-text">
            Please confirm whether the issue has been reviewed by the Sponsoring
            Ministry (at the Level of Secretary/concerned officer) before
            raising on the PMG Portal
          </div>
          <div
            className={`ministry-review-radio ${isChecked ? "active-Yes" : ""}`}
          >
            <div
              className={`layout-radio
                ${false ? "active" : ""}
                `}
              onClick={() => checkBoxChange("YES")}
              style={{ padding: "0px" }}
            >
              <Image src={isChecked ? radioblue : radioUncheck} />
              <span
                className={`ministry-review-text-bool ${
                  isChecked ? "active" : ""
                }`}
              >
                Yes, the issue has been reviewed
              </span>
            </div>
          </div>
          <div
            className={`ministry-review-radio ${
              isNotChecked ? "active-No" : ""
            }`}
          >
            <div
              className={`layout-radio ${isNotChecked ? "active" : ""}`}
              onClick={() => checkBoxChange("NO")}
              style={{ padding: "0px" }}
            >
              <Image src={isNotChecked ? radioblue : radioUncheck} />
              <span
                className={`ministry-review-text-bool ${
                  isNotChecked ? "active-text-no" : ""
                }`}
              >
                No, the issue has not been reviewed
              </span>
            </div>
          </div>
          {isChecked && (
            <div className="minutes-meeting-box">
              <div
                className="decision-issue-status"
                style={{ marginBottom: 0 }}
              >
                <Form.Group className="form-field d-flex flex-row align-items-center justify-content-between">
                  <div className="w-full" style={{ paddingLeft: 0 }}>
                    <Form.Label style={{ fontSize: 15 }} className="p-0">
                      Meeting Minutes
                      <span className="required">*</span>{" "}
                      <TooltipCustom
                        containerClass="tooltip-ministry"
                        text="Upload official Meeting Minutes issued during the Sponsoring Ministry review"
                      >
                        <Image src={Info} />
                      </TooltipCustom>
                    </Form.Label>
                    <div className="form-field">
                      <Field
                        as="textarea"
                        keyName="projectMOM"
                        style={{ width: "-webkit-fill-available" }}
                        onChange={projectMom}
                        value={description}
                        className={`agenda-mom-input ${
                          errors.projectMOM ? "error-mom-field" : ""
                        }`}
                        placeholder="Enter Minutes of the Meeting"
                        onBlur={onBlur}
                      />
                      {errors.projectMOM && (
                        <div className="invalid-feedback d-block">
                          {errors.projectMOM}
                        </div>
                      )}
                    </div>
                  </div>
                </Form.Group>
              </div>
              <div className="classFromReview agendaproject-add-decision-meeting">
                <DisplayAttachments
                  onTogglePopUp={onToggleAttachment}
                  filesArr={files}
                  onRemoveFile={onRemoveFile}
                  errorClass={errors.documents ? "error-mom-field" : ""}
                  isAgendaAttachment={true}
                  buttonTitle="ADD DOCUMENT*"
                  projectAdddecision={true}
                  isMinitryReview={true}
                />
                <span className="doc-text">
                  Supported File types: .doc and .pdf
                </span>
                <br />
                <span className="doc-text">Max File size: 10MB</span>
              </div>
              {toggleAttachementDisplay ? (
                <UploadMinutesForReviewComponent
                  displayModal={toggleAttachementDisplay}
                  onCloseModal={onToggleAttachment}
                  fileFormats={FORMAT_DOC_PDF}
                  isReview={true}
                />
              ) : null}
              {errors.documents && (
                <div className="invalid-feedback d-block margin-top-none">
                  {errors.documents}
                </div>
              )}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          {saveBtn ||
            (isChecked == null && isNotChecked == null ? (
              <TooltipCustom text="Select one option to proceed">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={saveHandler}
                  className="btn-orange"
                  data-test="yes-button"
                  disabled={isChecked == null && isNotChecked == null}
                >
                  Submit
                </Button>
              </TooltipCustom>
            ) : (
              <Button
                variant="primary"
                size="sm"
                onClick={saveHandler}
                className="btn-orange"
                data-test="yes-button"
                disabled={isChecked == null && isNotChecked == null}
              >
                Submit
              </Button>
            ))}
        </Modal.Footer>
      </section>
    </Modal>
  )) ||
  null;
